import Infos from './infos';
import InscriptionForm from './Inscription';



function Ajout() {
    return (
      <div >
        
<Infos/>
  
  <InscriptionForm/>
  
  
      </div>
    )
}export default Ajout